import { Injectable } from '@angular/core';
import { AttachmentHttpService } from '@app/core/async-services/http';
import { Chat } from '@app/core/models';
import { getUrlsFromText, showLinkPreview } from '@app/core/utils';
import {
  NewsFeedListItem,
  LinkPreview,
} from '@app/core/async-services/http/versioned/interfaces';
import { Message } from '@app/core/async-services/http/versioned/interfaces/chat.interface';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UrlPreviewService {
  constructor(private _attachmentHttpService: AttachmentHttpService) {}

  async getLinkPreviews(message: string): Promise<LinkPreview[]> {
    const urls = getUrlsFromText(message);
    return Promise.all(
      urls.map((url) =>
        firstValueFrom(this._attachmentHttpService.getLinkPreview(url)),
      ),
    ).then((previews) => previews.filter(showLinkPreview));
  }

  addLinkPreviews(obj: Message): Promise<Message>;
  addLinkPreviews(obj: NewsFeedListItem): Promise<NewsFeedListItem>;
  async addLinkPreviews(
    obj: Chat.Message | NewsFeedListItem,
  ): Promise<Chat.Message | NewsFeedListItem> {
    const message = 'newsFeedText' in obj ? obj.newsFeedText : obj.message;
    obj.linkPreviews = await this.getLinkPreviews(message);
    return obj;
  }

  addLinkPreviewsToMany(objs: Message[]): Promise<Message[]>;
  addLinkPreviewsToMany(objs: NewsFeedListItem[]): Promise<NewsFeedListItem[]>;
  async addLinkPreviewsToMany<T = NewsFeedListItem | Chat.Message>(
    objs: T[],
  ): Promise<Chat.Message[] | NewsFeedListItem[]> {
    return Promise.all(objs.map((obj) => this.addLinkPreviews(obj as any)));
  }
}
